import React from 'react';
import logo from '../../images/ConsultVision_logo.svg';
import './footer.scss';

export const Footer = () => {
  return (
    <footer className="footer" id="contact">
      <img src={logo} alt="company logo" className="logo_footer" />
      <div className="contacts_div">
        <div className="contact_left">
          <p>
            <strong>ConsultVision s.r.o.</strong> <br />
            Adresa: V Olšinách 16/82, Praha - Strašnice 100 00
            <br /> IČ: 07078145 | DIČ: CZ07078145
            <br />
            Email:{' '}
            <a target="_top" href="mailto:info@consultvision.cz">
              info@consultvision.cz
            </a>{' '}
          </p>
        </div>
        <div className="contact_right">
          <p>
            <br />
            Spisová značka: C 294283/MSPH Městský soud v Praze
            <br />
            Datum zápisu do obchodního rejstříku: 26. duben 2018 <br />
            Datová schránka: w6f8e8s
          </p>
        </div>
      </div>
    </footer>
  );
};
